module.exports = __webpack_public_path__ + "img/drug-18.9ec03345.png";